<template>
  <!-- ----------------------------------------------------------------------------- -->
  <!-- DatatablesCRUDActions -->
  <!-- ----------------------------------------------------------------------------- -->
  <div>
    <v-list-item-subtitle class="text-wrap">

    </v-list-item-subtitle>
    <div class="mt-4">
      <v-data-table :headers="headers" :items="listitems" sort-by="sequence" class="border" hide-default-footer dense>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Education</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="title">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row dense>
                      <v-col cols="12" sm="1" md="1">
                        <v-text-field v-model="editedItem.sequence" label="No." dense></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="11" md="11">
                        <v-text-field v-model="editedItem.qualification" label="Qualification (in full title)" dense></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="8" md="8">
                        <v-text-field v-model="editedItem.university" label="University" dense></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-select v-model="editedItem.country" :items="countries" label="Country" item-text="title" item-value="const" dense>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu ref="datecommselector" v-model="datecommselector" :close-on-content-click="false" :return-value.sync="datecommselector" transition="scale-transition" offset-y min-width="290px">
                           <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="editedItem.datecommence" label="Date Commenced" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense></v-text-field>
                           </template>
                           <v-date-picker v-model="editedItem.datecommence" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="datecommselector = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.datecommselector.save(editedItem.datecommence)">OK</v-btn>
                           </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu ref="datequaselector" v-model="datequaselector" :close-on-content-click="false" :return-value.sync="datequaselector" transition="scale-transition" offset-y min-width="290px">
                           <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="editedItem.datequalification" label="Date Qualified" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense></v-text-field>
                           </template>
                           <v-date-picker v-model="editedItem.datequalification" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="datequaselector = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.datequaselector.save(editedItem.datequalification)">OK</v-btn>
                           </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-if="editedIndex >= 0" v-model="editedItem.document" label="Uploaded Document" readonly dense></v-text-field>
                        <v-file-input v-model="uploadfile" label="Attach Document" append-icon="mdi-clip" accept=".png, .jpg, .pdf, .tiff" show-size dense/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="close">Cancel</v-btn>
                  <v-btn color="primary" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.sequence`]="{ item }">
           <small>{{ item.sequence }}</small>
        </template>
        <template v-slot:[`item.qualification`]="{ item }">
           <small>{{ item.qualification }}</small>
        </template>
        <template v-slot:[`item.university`]="{ item }">
           <small>{{ item.university }}</small>
        </template>
        <template v-slot:[`item.country`]="{ item }">
           <small>{{ formatCountry(item.country) }}</small>
        </template>
        <template v-slot:[`item.datecommence`]="{ item }">
           <small>{{ formatDate(item.datecommence) }}</small>
        </template>
        <template v-slot:[`item.datequalification`]="{ item }">
           <small>{{ formatDate(item.datequalification) }}</small>
        </template>
        <template v-slot:[`item.document`]="{ item }">
           <small v-if="documentUrl(item)">
              <a :href="documentUrl(item)" target="_blank" rel="noopener">{{ item.document }}</a>
           </small>
           <small v-else class="grey--text">-</small>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
      <v-dialog v-model="dlgconfirm" width="400" persistent dark>
         <v-card>
            <v-card-title class="title"><span class="text-white">Confirm you want to delete this?</span></v-card-title>
            <v-card-text>
               <v-row dense>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>No.</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.sequence }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Qualification</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.qualification }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>University</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.university }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Country</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.country }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Date Commenced</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ formatDate(todelete.datecommence) }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Date Qualified</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ formatDate(todelete.datequalification) }}</small>
                  </v-col>
                  <v-col cols="12" md="3" sm="3">
                     <small><b>Document</b></small>
                  </v-col>
                  <v-col cols="12" md="9" sm="9">
                     <small>{{ todelete.document }}</small>
                  </v-col>
               </v-row>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="red darken-1" dark @click="dodelete(todelete)">
                  Yes
               </v-btn>
               <v-btn color="primary" dark @click="dlgconfirm = false">
                  No
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
const axios = require('axios')
import CountriesItems from '../Forms/Countries.js'

export default {
   name: "TableQualEdu",
   data: () => ({
      user: Object,
      errors: Object,
      userid: 0,
      focus: false,
      datecommselector: false,
      datequaselector: false,
      dialog: false,
      countries: CountriesItems,
      headers: [
         {
            text: "No.",
            align: "start",
            sortable: true,
            value: "sequence"
         },
         {
            text: "Qualication",
            sortable: false,
            value: "qualification"
         },
         { text: "University", value: "university", sortable: false },
         { text: "Country", value: "country", sortable: false },
         { text: "Date Commenced", value: "datecommence", sortable: false },
         { text: "Date Qualification", value: "datequalification", sortable: false },
         { text: "Document", value: "document", sortable: false },
         { text: "Actions", value: "actions", sortable: false }
      ],
      listitems: [],
      submitting: false,
      deleting: false,
      dlgconfirm: false,
      confirmdelete: false,
      uploadfile: null,
      editedIndex: -1,
      editedItem: {
         id: 0,
         sequence: 0,
         qualification: "",
         university: "",
         country: "",
         datecommence: "",
         datequalification: "",
         document: "",
      },
      todelete: {
         id: 0,
         sequence: 0,
         qualification: "",
         university: "",
         country: "",
         datecommence: "",
         datequalification: "",
         document: "",
      },
      defaultItem: {
         id: 0,
         sequence: 0,
         qualification: "",
         university: "",
         country: "",
         datecommence: "",
         datequalification: "",
         document: "",
      }
   }),

   computed: {
      formTitle() {
         return this.editedIndex === -1 ? "Qualification (Education): New Item" : "Qualification (Education): Edit Item";
      }
   },

   watch: {
      dialog(val) {
         val || this.close();
      },
   },

   mounted() {
      this.$emit('QualEduMounted')
   },

   methods: {
      documentUrl(item) {
         if (!item || !item.document || !item.documentpath) {
            return null
         }

         var path = String(item.documentpath).replace(/^\/+|\/+$/g, '')
         var document = String(item.document).replace(/^\/+/g, '')
         return '/' + path + '/' + encodeURIComponent(document).replace(/%2F/g, '/')
      },

      formatDate(e) {
         if (!e) {
            return ''
         }
         const date = this.$moment(new Date(e))
         return date.isValid() ? date.format('DD/MM/YYYY') : ''
      },

      formatCountry(e) {
         var country = this.countries.find(obj => {
            return obj.const === e
         })
         return country ? country.title : (e || '')
      },

      setuserid(pUserID) {
         this.userid = pUserID || 0
         this.initialize()
      },

      initialize() {
         this.$nextTick(() => {
            var targetPath = ''
            this.uploadfile = null
            if (this.userid !== 0) {
               targetPath = '/member/qualedu/list/' + this.userid // get id from property
            } else {
               targetPath = '/member/qualedu/list' // get id from current login session (server-side)
            }
            axios.get(targetPath)
            .then((resp) => {
               if (resp.data) {
                  var rtn = resp.data
                  if (rtn.status === 'OK') {
                     this.listitems = Array.isArray(rtn.data) ? rtn.data : []
                  } else {
                     this.listitems = []
                     console.log(rtn.status + ': ' + rtn.error)
                  }
               }
            })
            .catch((error) => {
               this.listitems = []
               console.error('Unable to load education records.', error)
            })
         })
      },

      editItem(item) {
         this.editedIndex = this.listitems.indexOf(item);
         this.editedItem = Object.assign({}, item);
         this.dialog = true;
      },

      deleteItem(item) {
         this.todelete = item
         this.dlgconfirm = true
      },

      dodelete(item) {
         var targetPath = "/member/qualedu/delete"
         var data = {
            id: item.id
         }
         this.dlgconfirm = false
         this.deleting = true
         axios.post(targetPath, data)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.initialize()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
         .catch((error) => {
            console.error('Unable to delete education record.', error)
         })
         .finally(() => {
            this.deleting = false
         })
      },

      close() {
         this.dialog = false;
         setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
         }, 300);
      },

      save() {
         var targetPath = ""
         if (this.editedIndex > -1) {
            targetPath = "/member/qualedu/update"
         } else {
            targetPath = "/member/qualedu/add"
         }
         var data = new FormData()
         if (this.userid) {
            data.append('userid', this.userid)
         }
         if (this.editedIndex > -1) {
            data.append('id', this.editedItem.id)
         }
         data.append('sequence', this.editedItem.sequence)
         data.append('qualification', this.editedItem.qualification)
         data.append('university', this.editedItem.university)
         data.append('country', this.editedItem.country)
         data.append('datecommence', this.editedItem.datecommence)
         data.append('datequalification', this.editedItem.datequalification)
         if (this.uploadfile) {
            data.append('document', this.uploadfile)
         }

         this.submitting = true
         axios.post(targetPath, data, {
            headers: {
               'Content-Type': 'multipart/form-data'
            }
         })
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.initialize()
                  this.close()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }

         })
         .catch((error) => {
            console.error('Unable to save education record.', error)
         })
         .finally(() => {
            this.submitting = false
         })
      }

   }
};
</script>
